import type { Community } from '@communities/community/domain';
import { getApolloClient } from '@core/apollo/client';
import type { LoaderFunctionArgs } from 'react-router-dom';

import { GET_COMMUNITY_FOR_AUDIT } from '../graphql/getCommunityForAudit';

interface CommunityAuditLoaderData {
  community: Community;
}

/**
 * Loader for audit routes
 *
 * Fetches community data before rendering audit pages using the audit-specific query
 * that excludes moderationStats to prevent failures when Moderation Service is unavailable
 * or returns invalid data.
 *
 * This loader is specifically designed for audit routes and should not be used elsewhere.
 */
export async function communityAuditLoader({ params }: LoaderFunctionArgs): Promise<CommunityAuditLoaderData> {
  const client = getApolloClient();

  const { data } = await client.query<{ community: Community }>({
    query: GET_COMMUNITY_FOR_AUDIT,
    variables: { id: params.communityId },
    fetchPolicy: 'cache-first',
  });

  return { community: data.community };
}
